module.exports = __webpack_public_path__ + "img/outcome_partially_automated.646adacd.svg";